module.exports = function() {
  return new Worker(__webpack_public_path__ + "fa3a3d4cf8647a32b0a5.worker.js");
};